import { useState } from 'react';
import { useMutation } from 'react-apollo';

import { cardUpdate as cardUpdateMutation } from '../../../apps/cards/graphql/mutations/card';
import { cardTemplateUpdate as cardTemplateUpdateMutation } from '../../../apps/cards/graphql/mutations/cardTemplate';
import useOpenAlert from '../../../hooks/useOpenAlert';
import { getErrorString } from '../../../util/normalize-errors';

const useCardSettings = () => {
  const [loadingCardSettings, setLoadingCardSettings] = useState(false);
  const [cardUpdate] = useMutation(cardUpdateMutation);
  const [cardTemplateUpdate] = useMutation(cardTemplateUpdateMutation);
  const openAlert = useOpenAlert();

  const onCardSettingsUpdate = async ({ cardId, cardTemplateId, values }) => {
    if (loadingCardSettings) {
      return;
    }

    setLoadingCardSettings(true);

    try {
      if (cardId) {
        await cardUpdate({
          variables: {
            input: {
              card_id: cardId,
              name: values.card_name,
              ...values,
            },
          },
        });
      }

      if (cardTemplateId) {
        await cardTemplateUpdate({
          variables: {
            input: {
              card_template_id: cardTemplateId,
              ...values,
            },
          },
        });
      }
    } catch (error) {
      openAlert({ type: 'error', message: getErrorString(error) });
    } finally {
      setLoadingCardSettings(false);
    }
  };

  return {
    onCardSettingsUpdate,
    loadingCardSettings,
    cardTemplateUpdate,
  };
};

export default useCardSettings;
